function parsePoint(point) {
    var _a;
    return [point.x, point.y, (_a = point.z) !== null && _a !== void 0 ? _a : 0];
}
function toPointObject(point) {
    var _a;
    return { x: point[0], y: point[1], z: (_a = point[2]) !== null && _a !== void 0 ? _a : 0 };
}

export { parsePoint, toPointObject };
//# sourceMappingURL=point.js.map
